<template>
    <div>
        <div v-if="!historico">
            <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-between">
                <h4 class="font-weight-bold">Situação de Rua</h4>
                <a
                    class="font-weight-light font-italic"
                    role="button"
                    @click="historico = true"
                >
                    <i class="mdi mdi-history"></i>Histórico
                </a>
            </div>
            <div class="row">

                <form-select
                grid="2"
                    v-model="item.migrante"
                    label="Migrante?"
                    :itens="$root.arrays.pergunta"
                />
                <form-select
                    :grid="situacao.estado_origem ? '2' : '6'"
                    v-model="situacao.estado_origem"
                    label="Estado de origem"
                    :itens="$root.arrays.estados"
                    @change="getCidades"
                />
                <form-select
                    grid="4"
                    v-model="situacao.cidade_origem"
                    label="Cidade de origem"
                    :itens="cidades"
                    :loading="loadCidades"
                    v-if="situacao.estado_origem"
                />

                <form-select
                    grid="4"
                    v-model="situacao.status"
                    label="Status"
                    :itens="$root.arrays.status_situacao_rua"
                />
                <div class="col-md-8 col-sm-12 row">
                    <label class="font-weight-bold col-md-6 col-sm-12 mt-3">
                        Onde costuma dormir?
                    </label>
                    <label
                        class="font-weight-bold text-center col-md-6 col-sm-12 mt-3"
                    >
                        Quantas vezes por semana?
                    </label>
                    <div class="col-12">
                        <div class="row px-3 d-flex align-items-center">
                            <form-toggle
                                class="px-0 mb-0"
                                mt="0"
                                v-model="situacao.ind_dormir_rua_memb"
                                label="Rua"
                                grid="7"
                            />
                            <form-input
                                grid="5"
                                mt="1"
                                class="px-0"
                                type="number"
                                v-model="situacao.qtd_dormir_freq_rua_memb"
                                :disabled="situacao.ind_dormir_rua_memb ? false : true"
                                placeholder="Dorme na rua?"
                            />
                        </div>
                        <div class="row px-3 d-flex align-items-center">
                            <form-toggle
                                class="px-0 mb-0"
                                mt="0"
                                v-model="situacao.ind_dormir_albergue_memb"
                                label="Albergue"
                                grid="7"
                            />
                            <form-input
                                grid="5"
                                mt="1"
                                class="px-0"
                                type="number"
                                v-model="situacao.qtd_dormir_freq_albergue_memb"
                                placeholder="Dorme no albergue?"
                                :disabled="situacao.ind_dormir_albergue_memb ? false : true"
                            />
                        </div>
                        <div class="row px-3 d-flex align-items-center">
                            <form-toggle
                                class="px-0 mb-0"
                                mt="0"
                                grid="7"
                                v-model="situacao.ind_dormir_dom_part_memb"
                                label="Domicílio particular"
                            />
                            <form-input
                                grid="5"
                                mt="1"
                                class="px-0"
                                type="number"
                                v-model="situacao.qtd_dormir_freq_dom_part_memb"
                                placeholder="Dorme no domicílio particular?"
                                :disabled="situacao.ind_dormir_dom_part_memb ? false : true"
                            />
                        </div>
                        <div class="row px-3 d-flex align-items-center">
                            <form-toggle
                                class="px-0 mb-0"
                                mt="0"
                                grid="7"
                                v-model="situacao.ind_outro_memb"
                                label="Outro"
                            />
                            <form-input
                                grid="5"
                                mt="1"
                                class="px-0"
                                type="number"
                                v-model="situacao.qtd_freq_outro_memb"
                                placeholder="Dorme em outro Lugar?"
                                :disabled="situacao.ind_outro_memb ? false : true"
                            />
                        </div>
                    </div>
                </div>
                <form-radio
                    label="Há quanto tempo vive na rua?"
                    grid="4"
                    class="pl-4 pr-0 mt-2"
                    name="cod_tempo_rua_memb"
                    v-model="situacao.cod_tempo_rua_memb"
                    :itens="$root.arrays.cod_tempo"
                />
                <label class="col-12 font-weight-bold mt-3">
                    Quais os principais motivos pelos quais passou a morar na
                    rua/albergue/outro?
                </label>
                <div class="col-md-6 col-sm-12">
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_perda_memb"
                        label="Perda de moradia"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_ameaca_memb"
                        label="Ameaça/violência"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_probs_fam_memb"
                        label="Problemas com familiares/companheiro(a)"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_alcool_memb"
                        label="Alcoolismo/drogas"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_desemprego_memb"
                        label="Desemprego"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_trabalho_memb"
                        label="Trabalho"
                    />
                </div>
                <div class="col-md-6 col-sm-12">
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_saude_memb"
                        label="Tratamento de saúde"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_pref_memb"
                        label="Preferência/opção própria"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_outro_memb"
                        label="Outro"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_nao_sabe_memb"
                        label="Não sabe/não lembra"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_motivo_nao_resp_memb"
                        label="Não respondeu"
                    />
                </div>
                <form-radio
                    label="Há quanto tempo mora nesta cidade?"
                    grid="4"
                    name="cod_tempo_cidade_memb"
                    v-model="situacao.cod_tempo_cidade_memb"
                    :itens="$root.arrays.cod_tempo"
                />
                <form-radio
                label="Vive com sua família na rua?"
                    grid="4"
                    name="cod_vive_fam_rua_memb"
                    v-model="situacao.cod_vive_fam_rua_memb"
                    :itens="$root.arrays.perguntas"
                />
                <form-radio
                    label="Tem contato com parente que viva fora da rua?"
                    grid="4"
                    name="cod_contato_parente_memb"
                    v-model="situacao.cod_contato_parente_memb"
                    :itens="$root.arrays.cod_tempo_contato"
                />
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 mt-3">
                    <label class="font-weight-bold col-12 px-0">
                        Nos últimos seis meses (nome) frequentou ou participou
                        de alguma atividade comunitária?
                    </label>
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_ativ_com_escola_memb"
                        label="Escola"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_ativ_com_associação_memb"
                        label="Associação"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_ativ_com_coop_memb"
                        label="Cooperativa"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_ativ_com_mov_soc_memb"
                        label="Movimento social"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_ativ_com_nao_sabe_memb"
                        label="Não sabe/não lembra"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_ativ_com_nao_resp_memb"
                        label="Não respondeu"
                    />
                </div>
                <div class="col-md-6 col-sm-12 mt-3">
                    <label class="font-weight-bold col-12 px-0">
                        Nos últimos seis meses foi atendido(a)
                    </label>
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_atend_cras_memb"
                        label="Centro de Referência da Assistência Social - CRAS"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_atend_creas_memb"
                        label="Centro de Referência Especializado da Assistência Social - CREAS"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_atend_centro_ref_rua_memb"
                        label="Centro de referência para população em situação de rua"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_atend_inst_gov_memb"
                        label="Instituição de acolhimento governamental (albergue/abrigo/outro)"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_atend_inst_nao_gov_memb"
                        label="Instituição de acolhimento não-governamental (instituição beneficente privada/outro)"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_atend_hospital_geral_memb"
                        label="Hospital/clínica geral"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_consultorio_rua"
                        label="Consultório na Rua"
                    />
                    <form-toggle
                        class="px-0"
                        mt="0"
                        v-model="situacao.ind_atend_nenhum_memb"
                        label="Nenhum"
                    />
                </div>
                <div class="col-md-6  col-sm-12 mt-3">
                    <label class="font-weight-bold col-12 px-0">
                        O que faz para ganhar dinheiro?
                    </label>
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_dinh_const_memb"
                        label="Construção civil"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_dinh_flanelhinha_memb"
                        label="Guardador de carro/flanelinha"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_dinh_carregador_memb"
                        label="Carregador/estivador"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_dinh_catador_memb"
                        label="Catador de material reciclável"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_dinh_servs_gerais_memb"
                        label="Serviços gerais/limpeza /outro"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_dinh_pede_memb"
                        label="Pede dinheiro"
                    />
                    <form-toggle
                        class="px-0"
                        mt="0"
                        v-model="situacao.ind_dinh_vendas_memb"
                        label="Vendas"
                    />
                    <form-toggle
                        class="px-0"
                        mt="0"
                        v-model="situacao.ind_dinh_outro_memb"
                        label="Outro"
                    />
                    <form-toggle
                        mt="0"
                        class="px-0"
                        v-model="situacao.ind_dinh_nao_resp_memb"
                        label="Não respondeu"
                    />
                </div>
                <form-radio
                label="Alguma vez teve emprego com Carteira De Trabalho assinada?"
                    grid="6"
                    name="cod_cart_assinada_memb"
                    v-model="situacao.cod_cart_assinada_memb"
                    :itens="$root.arrays.perguntas"
                />
            </div>

            <div class="row pt-4 px-2 d-flex justify-content-end">
                <form-toggle
                    grid="9"
                    class="d-flex justify-content-end"
                    mt="0"
                    v-model="item.nova_condicao_situacao_rua"
                    label="Cadastrar novos dados de Situação de rua"
                />
                <button @click="submit" class="btn btn-success btn-submit">
                    <i class="mdi mdi-content-save"></i>
                    Salvar
                </button>
            </div>
        </div>
        <div v-else>
            <Historico
                :id="item.id"
                tipo="situacao"
                title="Situação de Rua"
                @voltar="historico = false"
            />
        </div>
    </div>
</template>
<script>
import Historico from "../Historico/SituacaoRua";
export default {
    components: { Historico },
    props: ["item"],
    data() {
        return {
            historico: false,
            loadCidades: false,
            situacao: {
                estado_origem: null,
            },
            cidades: [],
        };
    },
    mounted() {
        this.setValue();
        this.getCidades();
        this.situacao.cidade_origem = parseInt(this.situacao.cidade_origem);
    },
    watch: {
        item(n, o) {
            this.setValue();
        },
    },
    methods: {
        setValue() {
            if (this.item.situacao != null) {
                this.situacao = this.item.situacao;
            }
        },
        getCidades() {
            let estado = this.situacao.estado_origem;
            if (estado) {
                this.loadCidades = true;
                axios
                    .get("api/dashboard/enderecos/get/cidades/" + estado)
                    .then((response) => {
                        this.cidades = response.data;
                    })
                    .finally(() => {
                        this.loadCidades = false;
                    });
            }
        },
        submit() {
            this.item.situacao = this.situacao;
            this.$emit("submit");
        },
    },
};
</script>
